<script setup>
// @ts-check

import FilterSelect from '@/components/controls/FilterSelect.vue'
import * as _ from 'lodash-es'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import DateRangeField from '../fields/DateRangeField.vue'

defineProps({
  filters: {
    /** @type {import('vue').PropType<FilterItem[]>} */
    type: Array,
    default: null
  },
  disabled: {
    type: Boolean
  }
})

defineOptions({
  name: 'ServerDatatableControls'
})

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const updateSearch = _.debounce(async (search) => {
  await router.replace({
    query: { ...route.query, search: search || undefined, page: 1 }
  })
}, 500)

/** @param {[?string, ?string]} dateRange */
const updateDateRange = async (dateRange) => {
  await router.replace({
    query: {
      ...route.query,
      start_date: dateRange[0],
      end_date: dateRange[1],
      page: 1
    }
  })
}
</script>

<template>
  <div class="server-datatable-controls bg-white">
    <div v-if="$slots.header" class="flex flex-row flex-wrap justify-end">
      <slot name="header"></slot>
    </div>

    <div class="grid-controls md:grid-cols-2">
      <VTextField
        :model-value="route.query.search"
        :label="t('entries.search')"
        append-inner-icon="$magnify"
        @update:model-value="updateSearch"
      />

      <DateRangeField
        :model-value="[route.query.start_date, route.query.end_date]"
        :label="t('entries.search_date')"
        @update:model-value="updateDateRange"
      />
    </div>

    <FilterSelect v-if="filters?.length" :filters :disabled />
  </div>
</template>

<style lang="scss" scoped>
@reference '../../styles/main.css';

.server-datatable-controls {
  @apply divide-y-1 divide-solid divide-secondary-200;
  @apply rounded-md shadow;

  & > * {
    @apply p-3 md:px-4;
  }
}
</style>
